import { initUser, reset } from '@/features/app/reducer';
import { fetchFavorites } from '@/features/cleaners/reducer';
import { supabase } from '@/integrations/supabase/client';
import { APP_ROUTES } from '@/utils/appRoutes';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

const NOT_AUTH_ROUTES = [
  APP_ROUTES.WELCOME,
  APP_ROUTES.WAITING_LIST,
  APP_ROUTES.GUIDE,
  APP_ROUTES.REGISTER,
];

export const SessionSync = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //TODO -> gestire meglio rotte non autenticate
  const canAccessRoute = NOT_AUTH_ROUTES.includes(
    location.pathname as APP_ROUTES,
  );

  useEffect(() => {
    if (canAccessRoute) return;
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') {
        dispatch(reset());
      }
      if (!session?.user) {
        return navigate(APP_ROUTES.LOGIN);
      }
      if (event === 'SIGNED_IN') {
        dispatch(initUser());
        dispatch(fetchFavorites());
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [dispatch, canAccessRoute, navigate]);

  return null;
};
